import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Operation from '.';
import { signOut } from '../../auth/authSlice';

function OperationWrapper() {
    const dispatch = useDispatch();

    const user = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('user')) || {};
        } catch {
            return {};
        }
    }, []);

    const companyType = user?.companyID?.companyType;
    const allowedTypes = useMemo(() => [
        '000000000000000000000006',  // Installer
        '000000000000000000000005', // Authorized Reseller
        '000000000000000000000008',  // Sub Dealer
        '000000000000000000000004' //System Intergrator
    ], []);

    const isAllowed = allowedTypes.includes(companyType);

    useEffect(() => {
        if (!isAllowed) {
            dispatch(signOut({
                error: true,
                errorMessage: 'Access Restricted: Unauthorized Company Type',
                errorMessageData: 'This platform is exclusively for Authorized Resellers, Sub Dealers, Installers, and System Integrators. If you believe this is an error, please contact your system administrator for assistance.'
            }));
        }
    }, [isAllowed, dispatch]);

    if (!isAllowed) {
        return <p>Unauthorized access. Redirecting...</p>; // Fallback UI


    }

    return <Operation />;
}

export default OperationWrapper;
